<template>
  <crud-modal
    :title="$t('modals.user.addTitle')"
    action="create"
    :on-submit="submit"
    :on-close="() => $emit('close')"
    validation-scope="user"
    :error-message="errorMessage"
  >
    <user-form
      :company-id="companyId"
      :sso-providers="ssoProviders"
      :user="user"
    />
  </crud-modal>
</template>

<script>
import UserForm from './form'
import CrudModal from '@/components/modals/crud-modal'

import CREATE_USER from '@/graphql/CreateUser.gql'
import GET_USERS from '@/graphql/GetUsers.gql'

export default {
  components: {
    UserForm,
    CrudModal
  },
  props: {
    companyId: {
      type: String,
      required: true
    },
    ssoProviders: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      user: {
        salutation: '',
        firstname: '',
        lastname: '',
        email: '',
        role: {},
        ssoProviders: this.ssoProviders.reduce((acc, { issuer }) => {
          acc[issuer] = true
          return acc
        }, {}),
        receiveNotificationEmails: {
          leadAction: true
        },
        isSso: this.$features.feature('sso').isActive
      },
      errorMessage: ''
    }
  },
  methods: {
    async submit () {
      const { id, salutation, firstname, lastname, email, isSso, role: { id: roleId }, receiveNotificationEmails } = this.user
      try {
        await this.$apollo.mutate({
          mutation: CREATE_USER,
          variables: {
            input: {
              companyId: this.companyId,
              id,
              salutation,
              firstname,
              lastname,
              email,
              isSso,
              isPassive: isSso,
              role: roleId,
              ssoProviders: this.ssoProviders
                .filter(({ issuer }) => this.user.ssoProviders[issuer])
                .map(({ issuer }) => issuer),
              receiveNotificationEmails
            }
          },
          refetchQueries: [
            { query: GET_USERS, variables: { input: { companyId: this.companyId } } }
          ]
        })
      } catch (error) {
        const emailError = error.graphQLErrors?.[0]?.extensions?.details?.[0]?.type === 'is-unique'
        if (emailError) {
          this.errorMessage = this.$t('modals.user.form.emailAlreadyExists')
        } else {
          this.errorMessage = this.$t('modals.user.form.unknownError')
        }
        throw error
      }
    }
  }
}
</script>
